import React, { FC, useMemo } from 'react';

import { SearchableSelectType } from 'components/inputs/searchableSelect';
import AampeCreateSelectDropdown from 'components/shared/AampeCreateSelectDropdown/AampeCreateSelectDropdown';
import styled from 'styled-components';

import aampeTheme from '../../../constants/aampeTheme';

import useAllTopicQuery from 'hooks/topic-management/useAllTopicQuery';

interface TopicListDropdownProps {
    selectedTopicValue: string;
    handleChange: (
        field: string,
        value: SearchableSelectType | SearchableSelectType[],
    ) => void;
    isDisabled: boolean;
    menuPortalTarget?: HTMLElement;
    label?: string;
    field?: string;
}
const TopicListDropdown: FC<TopicListDropdownProps> = ({
    selectedTopicValue,
    handleChange,
    isDisabled,
    menuPortalTarget,
    label,
    field,
}) => {
    const { data, isLoading } = useAllTopicQuery();

    const options = useMemo<SearchableSelectType[]>(() => {
        if (!data) return [];

        return data.map((topic) => ({
            label: topic.name,
            value: topic.id,
        }));
    }, [data]);

    const value = useMemo<SearchableSelectType | undefined>(() => {
        const topic = data?.find((topic) => topic.id == selectedTopicValue);
        if (topic) {
            return {
                label: topic.name,
                value: topic.id,
            };
        }
        return undefined;
    }, [data, selectedTopicValue]);

    return (
        <Container>
            <AampeCreateSelectDropdown
                isDisabled={isDisabled}
                infoDescription="Topics help organise content internally by theme, user journey stage, or product feature, and do not impact agent learning."
                label={label || 'Topic'}
                name={field || 'topic'}
                isLoading={isLoading}
                options={options}
                menuPortalTarget={menuPortalTarget}
                value={value}
                onChange={handleChange}
                isClearable={false}
                creatable={false}
            />
        </Container>
    );
};

export default TopicListDropdown;

const Container = styled.div(() => ({
    backgroundColor: aampeTheme.colors.white,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: aampeTheme.borderRadius.medium,
    gap: aampeTheme.spacing4(3),
    height: '100%',
    width: '100%',
}));
